module.exports = __webpack_public_path__ + "static/media/kadir.960c0f77.jpg";